import type { APIRequestQueryParams, APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type Investor = APIResponse<'/api/v4/investors'>[number];
export type InvestorsQuery = APIRequestQueryParams<'/api/v4/investors'>;

export const fetchInvestors = (params: InvestorsQuery) =>
  get<Investor[]>('/v4/investors', { params });
